import leoProfanity from 'leo-profanity';

leoProfanity.loadDictionary('en');

export function isProfane(text) {
  return leoProfanity.check(text);
}
